import React, { useEffect, useState } from 'react'
import defultImage from "../../assets/svg/defultImage.svg"
import {Add, Close, SaveAlt, Search, Tune, ArrowForwardIosOutlined } from '@mui/icons-material'

import vanImg from "../../assets/svg/Van.svg"
import { Autocomplete, BottomNavigation, BottomNavigationAction, Box, Checkbox, FormControl, FormControlLabel, IconButton, InputAdornment, Menu, MenuItem, OutlinedInput, Paper, Rating, Stack, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { RiArrowRightSLine } from 'react-icons/ri';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Link, useParams } from 'react-router-dom';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import CircleIcon from '@mui/icons-material/Circle';
import pendingIcon from "../../assets/svg/State Icons 3.svg"
import paidIcon from "../../assets/svg/Check icon.svg"

import totalReviewsIcon from "../../assets/svg/review (1) 1.svg"
import avarageIcon from "../../assets/svg/star 1.svg"
import fiveStarIcon from "../../assets/svg/Group 162904.svg"
import complaintIcon from "../../assets/svg/Frame 1618873057.svg"

import carImg from "../../assets/svg/Rectangle 3463266.svg"
import cameraIcon from "../../assets/svg/CameraIcon.svg";
import defaultImage from "../../assets/svg/defultImage.svg";
import { Modal } from 'react-bootstrap';
import dayjs from 'dayjs';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { DataGrid } from '@mui/x-data-grid';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import axios from 'axios';
import { newHost } from '../Categories/CategoryProfile';
import { useSelector } from 'react-redux';
import { newImageUrl } from '../Manufacturers/ManufactureProfile';
import { toast } from 'react-toastify';
import noData from "../../assets/svg/Emptyfile1.svg"
import { Controller, useForm } from 'react-hook-form';
import DeleteModal from '../../components/Modals/DeleteModal';
const StaffProfile = () => {
 const { user } = useSelector((state) => state.auth);
const token = "Bearer " + user?.token;
    const [value, setValue] = useState(0);
    const [showNoteModal, setShowNoteModal] = useState(false)
    const [showReviewNoteModal, setShowReviewNoteModal] = useState(false)
    const [showRole, setShowRole] = useState(false);
    const [showPermissionView, setShowPermissionView] = useState(false);
    const [Othershow, setOtherShow] = useState(false);
    const [veiwPermission, setVeiwPermission] = useState(false);
    const [noteStaffDetails, setNoteStaffDetails] = useState(null)

    
const handlePermissionButton  = ()=>{
setVeiwPermission(!veiwPermission)

  }
   
       
     const handleReviewNoteModalShow = (note) =>{
                setNoteStaffDetails(note)
                setShowReviewNoteModal(true)
            }
     const handleReviewNoteModalClose = () =>{
                setShowReviewNoteModal(false)
            }
     const handleRoleModalShow = () =>{
               setSelectedRoleIds(staffRoleIds);
                setShowRole(true)
            }
     const handleRoleModalClose = () =>{
                setShowRole(false)
            }
     const handlePermissionViewShow = (roleId) =>{
                setRoleId(roleId)
                setShowPermissionView(true)
            }
     const handlePermissionViewClose = () =>{
                setShowPermissionView(false)
            }
              
  const handleOtherShow = ()=>{
    setOtherShow(true)
  }
    const handleOtherClose =()=>{
    setOtherShow(false)
  }
    const [expanded, setExpanded] = useState(null);
  const [checked, setChecked] = useState({});

  const handleToggleExpand = (index) => {
    setExpanded(expanded === index ? null : index);
  };
  const permissionsList = ["Create", "Read", "Upload", "Delete", "Force Del", "Restore"];
  const permissionsData = [
  {
    category: "Equipment Management",
    subcategories: [
      "Equipment Models",
      "Equipment Units",
      "Equipment Maintenance",
      "Equipment Insurance",
      "Equipment Inspection",
    ],
  },
  {
    category: "Vehicles Management",
    subcategories: ["Vehicles List", "Vehicle Assignments"],
  },
];

 
     const clientsReviewsCard = [
      {
      image : totalReviewsIcon,
      borderColor:"#696969",
      backgroundColor:"#F8F8F8",
      title:"Total Reviews",
      value:"124"
     },
      {
      image : avarageIcon,
      borderColor:"#FEB91E",
      backgroundColor:"#FFFAEA",
      title:"Average Rating",
      value:"4.6"
     },
      {
      image : fiveStarIcon, 
      borderColor:"#3FBEAC",
      backgroundColor:"#ECF9F7",
      title:"5-Star Rate",
      value:"68%"
     },
      {
      image : complaintIcon,
      borderColor:"#A80101",
      backgroundColor:"#A801010D",
      title:"Complaint Rate",
      value:"15%"
     },
    ]
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
      });
    
     
      const columns = [
        {
          field: "id",
          headerName: "Expense ID",
          flex: 0.7,
          minWidth: 120,
          renderCell: (params) => (
            <strong>{`# ${params.row.id}`}</strong>
          ),
        },
        {
          field: "van_id",
          headerName: "Van",
          flex: 0.7,
          minWidth: 120,

        },
        {
          field: "expense_type",
          headerName: "Type",
          flex: 0.8,
          minWidth: 120,
         
        },
        {
          field: "amount",
          headerName: "Amount",
          flex: 0.9,
          minWidth: 120,
          renderCell: (params) =>
            <div className='fw-bold'>{`${Number(params.row?.amount)?.toLocaleString("en-US")} EGP`}</div>
        },
        {
          field: "created_at",
          headerName: "Date",
          flex: 1.2,
          minWidth: 120,
          renderCell: (params) =>
              <div 
                     style={{
          
      whiteSpace: 'normal',
      lineHeight: 1.8,
          
        }}
                    className="d-flex flex-column justify-content-center align-items-center">
                        <span>{new Date (params.row?.created_at).toLocaleDateString()}</span>
                        <span>{new Date (params.row?.created_at).toLocaleTimeString()}</span>
                    </div>
        },
   
        {
          field: "status",
          headerName: "Status",
          flex: 0.9,
          minWidth: 120,
          // renderCell: (params) => (
          //   <div className="d-flex gap-2 align-items-center justify-content-center">
          //     <img
          //       src={
          //         params.row?.status?.image
          //           ? `${newImageUrl}${params.row.status.image}`
          //           : defaultImg
          //       }
          //       width={20}
          //     />
          //     <span>{params.row?.status?.name}</span>
          //   </div>
          // ),
        },
        {
          field: "actions",
          headerName: "Actions",
          flex: 0.9,
          minWidth: 120,
          sortable: false,
          renderCell: (params) => (
            <>
            
            <div className=''>
      <IconButton
              disableRipple
              size="small"
              onClick={(e) => {handleReviewDetailsModalShow(params.row)
                e.stopPropagation()
              }}
            >
              <RemoveRedEyeOutlinedIcon fontSize="small" />
            </IconButton>
            <IconButton
              disableRipple
              size="small"
              onClick={(e) => {handleExpenseDeleteShow(params.row.id)
                e.stopPropagation()
              }}
            >
              <DeleteOutlineOutlinedIcon color='error' fontSize="small" />
            </IconButton>
            </div>
      
          
            
            </>
          )
        },
      ];
    


   
  const [searchQuery, setSearchQuery] = useState("");
  const [filterDate, setFilterDate] = useState("");
   const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);

        const handleCheckboxChange = (cat, sub, perm) => {
    setChecked((prev) => ({
      ...prev,
      [cat]: {
        ...prev[cat],
        [sub]: {
          ...prev[cat]?.[sub],
          [perm]: !prev[cat]?.[sub]?.[perm],
        },
      },
    }));
  };
      const {id: staffId} = useParams()
      const [staffData, setStaffData] = useState({})
      const [staffRoles, setStaffRoles] = useState([])
      const [filteredRoles, setFilteredRoles] = useState([]);
      const [staffRoleIds, setStaffRoleIds] = useState([])
      const [roles, setRoles] = useState([])
      const [selectedRoleIds, setSelectedRoleIds] = useState([]); 

 const  getStaff = async ()=>{
        try {
          const response = await axios.get(`${newHost}portal/stuffs/${staffId}`,{
            headers:{Authorization: token }
          })
          console.log(response.data.data.stuff);
          
          setStaffData(response.data.data.stuff)
        } catch (error) {
          console.log(error);
          
        }
   }  
   
   // Orders tab
 
   const [staffOrders, setStaffOrders] = useState([])
   const [selectedDate, setSelectedDate] = useState(null);
   const [driverTrips, setDriverTrips] = useState([]);

const getStaffOrders = async () => {
  try {
    const response = await axios.get(
      `${newHost}portal/stuffs/${staffId}/view-orders${
        selectedDate
          ? `?date=${new Date(selectedDate).toLocaleDateString()}`
          : ""
      }`,
      { headers: { Authorization: token } }
    );

    const orders = response.data.data?.orders || [];

    const driverTrips = orders.flatMap((order) =>
      order.trips.filter(
        (trip) => trip.driver_id == staffId
      )
    );

    setStaffOrders(orders);
    setDriverTrips(driverTrips);

  } catch (error) {
    console.log(error);
  }
};
useEffect(() => {
 getStaffOrders()
}, [selectedDate])
// role tab
const getStaffRoles = async () => {
  try {
    const response = await axios.get(
      `${newHost}portal/stuffs/${staffId}/view-roles`,
      { headers: { Authorization: token } }
    );
 
    const roles = response.data.data.roles;
    setStaffRoles(roles);

    const roleIds = roles.map((r) => r.role?.id);
    setStaffRoleIds(roleIds);

  } catch (error) {
    console.log(error);
  }
};
const handleSubmitRoles = async () => {
  try {
   const response =  await axios.post(
      `${newHost}portal/stuffs/${staffId}/sync-roles`,
      {
        roles: selectedRoleIds 
      },
      {
        headers: { Authorization: token }
      }
    );

    handleRoleModalClose()
    getStaffRoles();                 
    toast.success(response.data.message)

  } catch (error) {
    console.log(error);
    toast.error(error.response.data.message)
  }
};


   const getRoles  = async ()=>{
            try {
          const response = await axios.get(`${newHost}portal/get-roles`,{
            headers:{Authorization: token }
          })
          console.log(response.data.data.roles);
          
          setRoles(response.data.data.roles)
        } catch (error) {
          console.log(error);
          
        }
   }

     const [showDeleteRole, setShowDeleteRole] = useState(false)
     const [roleId, setRoleId] = useState(null);

     const handleDeleteRoleShow = (id)=>{
       setRoleId(id)
       setShowDeleteRole(true)
     }  
     const handleDeleteRoleClose = ()=>{
       setShowDeleteRole(false)
     }
   
     const deleteStaffRole = async ()=>{
         try {
           const response = await axios.post(`${newHost}portal/stuffs/${staffId}/delete-role`,{
            role_id: roleId
           }, {
             headers: {Authorization: token}
           })
           toast.success(response.data.message)
           handleDeleteRoleClose()
           getStaffRoles()
         } catch (error) {
           toast.error(error.response.data.message)
           
         }
     }
   const [permissionReview, setPermissionReview] = useState([]);
   const getPermissionRoleReview  = async ()=>{
            try {
          const response = await axios.get(`${newHost}portal/get-permissions?role_id=${roleId}`,{
            headers:{Authorization: token }
          })
          console.log(response.data.data.permissions);
          
          setPermissionReview(response.data.data.permissions)
        } catch (error) {
          console.log(error);
          
        }
   }
   useEffect(() => {
   getStaff()
   getStaffRoles()
   getPermissionRoleReview()
   }, [])
   useEffect(() => {
  
   getRoles()
   }, [])
   useEffect(()=>{
    let data = [...roles]
   if (searchQuery.trim() !== "") {
      const search = searchQuery.toLowerCase();
      data = data.filter(
        (item) =>
  
          item.name
            ?.toLowerCase()
            .includes(search)
      );
    }
    setFilteredRoles(data)

   },[searchQuery,roles])
  // note tab
   const [staffNotes, setStaffNotes] = useState([])
   const getStaffNotes = async ()=>{
                try {
          const response = await axios.get(`${newHost}portal/stuffs/${staffId}/get-notes`,{
            headers:{Authorization: token }
          })
          console.log(response.data.data.notes);
          
          setStaffNotes(response.data.data.notes)
        } catch (error) {
          console.log(error);
          
        }
   }
      const NotesColumns = [
        {
          field: "id",
          headerName: "Note ID",
          flex: 1,
          minWidth: 120,
          renderCell: (params) =>
            params.row?.note?.id
      
        },
        {
          field: "title",
          headerName: "Title",
          flex: 1,
          minWidth: 120,
        renderCell: (params) =>
            params.row?.note?.title
        },
        {
          field: "created_at",
          headerName: "Date",
          flex: 0.9,
          minWidth: 120,
          renderCell: (params) =>
            new Date(params.row?.created_at).toLocaleDateString(),
        },
        {
          field: "status",
          headerName: "Status",
          flex: 0.9,
          minWidth: 120,
          renderCell: (params) => (
            <div className="d-flex gap-2 align-items-center justify-content-center">
              <img
                src={
                  params.row?.is_read == true ?
                     paidIcon
                    : 
                    pendingIcon
                }
                width={20}
              />
              <span>{params.row?.is_read == true ? "Read" : "Unread" }</span>
            </div>
          ),
        },
        {
          field: "actions",
          headerName: "Actions",
          flex: 0.9,
          minWidth: 120,
          sortable: false,
          renderCell: (params) => (
        <>
           <IconButton onClick={(e)=>{handleReviewNoteModalShow(params.row)
            e.stopPropagation()
           }} disableRipple>
                              <RemoveRedEyeOutlinedIcon/>
                            </IconButton>
                            <IconButton onClick={(e)=>{
                              e.stopPropagation()
                              handleDeleteShow(params.row.note?.id)}} color='error' disableRipple>
                              <DeleteOutlineOutlinedIcon/>
                            </IconButton>
        </>
          ),
        },
      ]; 
   useEffect(()=>{
      getStaffNotes()
   },[])
     const handleNoteModalShow = () =>{
                setShowNoteModal(true)
                
            }
     const handleNoteModalClose = () =>{
      
            setShowNoteModal(false)
            setIsEditNote(false)
            resetNotes()
            }
   const { register: registerNotes, handleSubmit: handleSubmitNotes, setValue: setValueNotes, reset: resetNotes} = useForm()
   const [isEditNote, setIsEditNote] =useState(false)
   const submitStaffNotes = async (data)=>{
        console.log(data);
        if(isEditNote){
 
        }else{
          try {
            const response = await axios.post(`${newHost}portal/stuffs/${staffId}/add-note`,{
              title: data.title,
              content: data.content
            },{
              headers: {Authorization:token}
            })
            toast.success(response.data.message)
            handleNoteModalClose()
            getStaffNotes()
          } catch (error) {
            toast.error(error.response.data.message)
          }
        }

        
   }
     const [noteId, setNoteId] = useState(null)
     const [showDelete, setShowDelete] = useState(false)
   
     const handleDeleteShow = (id)=>{
       setNoteId(id)
       setShowDelete(true)
     }  
     const handleDeleteClose = ()=>{
       setShowDelete(false)
     }
   
     const deleteStaffNote = async ()=>{
         try {
           const response = await axios.delete(`${newHost}portal/stuffs/${staffId}/notes/${noteId}/delete-note`, {
             headers: {Authorization:`${token}`}
           })
           toast.success(response.data.message)
           handleDeleteClose()
           getStaffNotes()
         } catch (error) {
           toast.error(error.response.data.message)
           
         }
     }
     // Exoenses Tap 
        
     const [statisticsExpenses, setStatisticsExpenses] = useState([])
     const [staffExpenses, setStaffExpenses] = useState([])

     const getExpensesData =  async ()=>{
         try {
          const response = await axios.get(`${newHost}portal/stuffs/${staffId}/expenses`,{
            headers: {Authorization:token}
          })
          setStatisticsExpenses(response.data.data.statistics)
          setStaffExpenses(response.data.data.expenses)
         } catch (error) {
          console.log(error);
          
         }
     }
     useEffect(() => {
      getExpensesData()
     }, [])
      const [expenseId, setExpenseId] = useState(null)
      const [showExpenseDelete, setShowExpenseDelete] = useState(false)
     
       const handleExpenseDeleteShow = (id)=>{
         setExpenseId(id)
         setShowExpenseDelete(true)
       }  
       const handleExapenseDeleteClose = ()=>{
         setShowExpenseDelete(false)
       }
     
       const deleteExpense = async ()=>{
           try {
             const response = await axios.delete(`${newHost}portal/stuff_expenses/${expenseId}/delete`, {
               headers: {Authorization:`${token}`}
             })
             toast.success(response.data.message)
             handleExapenseDeleteClose()
             getExpensesData()
           } catch (error) {
             toast.error(error.response.data.message)
             
           }
       }
       const [showReviewDetails, setShowReviewDetails] = useState(false)
       const [expenseDetails, setExpenseDetails] = useState(null)
       const [updateStatus, setUpdateStatus] = useState({
             status:null,
             notes:null
           })
        const [statusId, setStatusId] = useState(null)
        const [submitChangeStatus, setSubmitChangeStatus] = useState('')
        const [expensesStatuses, setExpensesStatuses] = useState([])  
        const [filteredExpenses, setFilteredExpenses] = useState([]);
               const [activeImage, setActiveImage] = useState(null);
           const handleDownload = () => {
             if (!activeImage?.full_image_url) return;
           
             const link = document.createElement("a");
             link.href = activeImage.full_image_url;
             link.setAttribute("download", "");
             link.setAttribute("target", "_blank"); 
             document.body.appendChild(link);
             link.click();
             document.body.removeChild(link);
           };
        const handleReviewDetailsModalShow = (item) => {

  setShowReviewDetails(true);
  setExpenseDetails(item);
     if(item){
  const firstActiveImage = item?.images?.length > 0 ? item?.images[0] : null
    setActiveImage(firstActiveImage)
    }
    setStatusId(item.id)
  

  const selectedStatus = expensesStatuses.find(
    (e) => e.value == item.status
  );

  setUpdateStatus({
    status: selectedStatus
      ? {
          label: selectedStatus.key,
          id: selectedStatus.value,
          icon: selectedStatus.icon,
        }
      : null,
    notes: null,
  });
};

     const handleReviewDetailsModalClose = () =>{
                setShowReviewDetails(false)
                setUpdateStatus({
                  status:null,
                  notes:""
                })
            } 

  const getExpensesStatuses = async ()=>{
            try {
              const response = await axios.get(`${newHost}portal/expense_statuses`, {
                headers: {Authorization:`${token}`}
              })
              setExpensesStatuses(response.data.data.expense_statuses)
            } catch (error) {
              console.log(error);
              
            }
          }

               const handleUpdateStatus = async ()=>{
    const formData = new FormData()
      if(updateStatus.notes){
        formData.append("reject_reason", updateStatus.notes)

      }
      formData.append("status", updateStatus.status?.id)
       try {
        const response = await axios.post(`${newHost}portal/stuff_expenses/${statusId}/update`,
          formData
        , {
          headers: {Authorization:`${token}`}
        })
        toast.success(response.data.data.message) 
        handleReviewDetailsModalClose()
        getExpensesData()
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message)
      }
   }
   useEffect(() => {
    getExpensesStatuses() 
   
   }, [])

  useEffect(() => {
     let data = [...staffExpenses];
 
 
   if(submitChangeStatus){
     const filteredStatus = submitChangeStatus.toLowerCase()
     data = data.filter((item)=> item.status_details?.key?.toLowerCase().includes(filteredStatus) )
   }
   
    
 
     setFilteredExpenses(data);
     setPaginationModel((prev) => ({ ...prev, page: 0 }));
   }, 
   [staffExpenses, submitChangeStatus]);


  // Shifts tab

   const [shiftDetailsShow, setShiftDetailsShow] = useState(false) 
   const [shiftDetails, setShiftDetails] = useState(null) 
   const [staffShifts, setStaffShifts] = useState([])

   const handleShiftDetailsModalShow = (shift)=>{
    setShiftDetailsShow(true)
    setShiftDetails(shift)
   }
   const handleShiftDetailsModalClose = ()=>{
    setShiftDetailsShow(false)
   }


   const ShiftsColumns = [
        {
          field: "id",
          headerName: "Shift ID",
          flex: 1,
          minWidth: 120,
          renderCell: (params) =>
          <div>{`#${params.row?.id}`}</div>
      
        },
        {
          field: "vehicle_id",
          headerName: "Van",
          flex: 1,
          minWidth: 120,
        renderCell: (params) =>
            <div>{`Van #${params.row?.vehicle_id}`}</div>
        },
        {
          field: "created_at",
          headerName: "Date",
          flex: 0.9,
          minWidth: 120,
          renderCell: (params) =>
            new Date(params.row?.created_at).toLocaleDateString(),
        },
        {
          field: "start_shift",
          headerName: "Start Shift",
          flex: 0.9,
          minWidth: 120,
          renderCell: (params) => (
            <div className="d-flex gap-2 align-items-center justify-content-center">
              <img
                src={
                params.row?.image_after? `${newImageUrl}${params.row?.after}` : defaultImage
                }
                width={20}
              />
              <span>{new Date(params.row?.started_at)?.toLocaleTimeString()}</span>
            </div>
          ),
        },{
          field: "end_shift",
          headerName: "End Shift",
          flex: 0.9,
          minWidth: 120,
          renderCell: (params) => (
            <div className="d-flex gap-2 align-items-center justify-content-center">
              <img
                src={
                  params.row?.image_after? `${newImageUrl}${params.row?.after}` : defaultImage
                }
                width={20}
              />
              <span>{new Date(params.row?.ended_at)?.toLocaleTimeString()}</span>
            </div>
          ),
        },
        {
          field: "actions",
          headerName: "Actions",
          flex: 0.9,
          minWidth: 120,
          sortable: false,
          renderCell: (params) => (
        <>
           <IconButton onClick={(e)=>{handleShiftDetailsModalShow(params.row)
            e.stopPropagation()
           }} disableRipple>
                              <ArrowForwardIosOutlined/>
                            </IconButton>
                          
        </>
          ),
        },
      ]; 
   const shiftsRows = [{
    id:"1",
    van_id:"38",
    created_at:"14 Dec,2025",
    start_shift:"09:00 AM",
    end_shift: "5:00 PM",
    actions:""
   }]

  const getStaffShifts = async ()=>{
            try {
              const response = await axios.get(`${newHost}stuff/shifts/get-shifts/${staffId}`, {
                headers: {Authorization:`${token}`}
              })
              setStaffShifts(response.data.data.data)
            } catch (error) {
              console.log(error);
              
            }
          }
 useEffect(() => {
   getStaffShifts()
 
 }, [])
 
   // Edit Staff Data
     const [staffDetails, setStaffDetails]= useState({})
     const [imagePreview, setImagePreview] = useState(null)
     const [imageLicensePreview, setImageLicensePreview] = useState(null)
     const [staffStatus, setStaffStatus] = useState({})
     const [licenseStatus, setLicenseStatus] = useState([])
     const [licenseTypes, setLicenseTypes] = useState([]) 

      const [show, setShow] = useState(false);
       
       const handleClose = () => {
           reset({
             profile_photo: null,
             license_photo: null,
             first_name: "",
             last_name: "",
             job_title_ids: [],
             joined_at: null,
             phone_number: "",
             birth_date: null,
             gender: "",
             username: "",
             email: "",
             password: "",
             password_confirmation: "",
             license_status:"",
             license_types:"",
             license_number:"",
             status:""
       
           });
           setSelectedJobTitleName([])
           setShow(false);
           setImagePreview(null)
           setImageLicensePreview(null)
         };
       const FileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
      setStaffValue("profile_photo", file);
    };
    reader.readAsDataURL(file);
  };
      const handleUpdateStaff =  (staff,e)=>{
           setStaffDetails(staff)
           console.log(staff);
           setShow(true)
          
           setStaffValue(
     "job_title_ids",
     staff.job_titles?.map(job => job.id)
   );
   
           setStaffValue("first_name", staff.first_name)
           setStaffValue("last_name", staff.last_name) 
           setStaffValue("birth_date",staff.birth_date? dayjs(staff.birth_date) : null)
           setStaffValue("joined_at", staff.joined_at? dayjs(staff.joined_at) : null)
           
           setStaffValue("username", staff.username) 
           setStaffValue("phone_number", staff.phone_number) 
           setStaffValue("email", staff.email) 
           setStaffValue("status", staff.status) 
           setStaffValue("gender", staff.gender) 
             if(staff.job_titles.some((job)=> job.title == "Driver")){
           setSelectedJobTitleName("Driver")
           setStaffValue("expired_date",staff.driver_license?.expired_date? dayjs(staff.driver_license.expired_date) : null)
           setStaffValue("renewal_date", staff.driver_license?.renewal_date? dayjs(staff.driver_license.renewal_date) : null)
           setStaffValue("license_status", staff.driver_license?.status) 
           setStaffValue("license_number", staff.driver_license?.license_number) 
           setStaffValue("license_type_id", staff.driver_license?.license_type_id) 
           if(staff.driver_license?.license_photo_path){
             setImageLicensePreview(`${newImageUrl}${staff.driver_license?.license_photo_path}`)
           }
           }
           if(staff.profile_photo_path){
           setImagePreview(`${newImageUrl}${staff.profile_photo_path}`)
         } 
         } 
        const onSubmit = async (data,e) => {
          console.log(data);
          const formData = new FormData();
      
      if (data.profile_photo instanceof File) {
        formData.append("profile_photo", data.profile_photo);
      } 
      
      
      
      
       formData.append("_method", "PATCH");
          
          
          data.job_title_ids?.forEach((job, index)=>
          formData.append(`job_title_ids[${index}]`, job)
          )
          formData.append("first_name", data.first_name);
          formData.append("last_name", data.last_name);
          formData.append("username", data.username);
          formData.append("gender", data.gender);
          formData.append("status", data.status);
          formData.append("phone_number", data.phone_number);
          formData.append("email", data.email);
          
             if(selectedjobTitleName?.includes("Driver") ){
         formData.append("license_type_id", data.license_type_id);
          formData.append("license_number", data.license_number);
         
          formData.append("license_status", data.license_status);
         if (data.license_photo instanceof File) {
        formData.append("license_photo", data.license_photo);
      }
       formData.append(
          "expired_date",
          data.expired_date ? dayjs(data.expired_date).format("YYYY-MM-DD") : ""
        );
      
        formData.append(
          "renewal_date",
          data.renewal_date ? dayjs(data.renewal_date).format("YYYY-MM-DD") : ""
        );
             }
         formData.append(
          "birth_date",
          data.birth_date ? dayjs(data.birth_date).format("YYYY-MM-DD") : ""
        );
        formData.append(
          "joined_at",
          data.joined_at ? dayjs(data.joined_at).format("YYYY-MM-DD") : ""
        );
      
       
          
          try {
            const response = await axios.post(
              `${newHost}portal/stuffs/${staffId}`,
              formData,
              {
                headers:{Authorization: token}
              },
      
            );
      
            console.log(response.data);
            toast.success(response.data.message);
            handleClose();
            getStaff()
          } catch (error) {
            toast.error(error.response?.data?.message);
            console.log(error);
          }
        
        };
         // gender data
     const gender = ["male", "female"];
         
         
            // job titles
     const [jobTitles, setjobtitles] = useState([]);
    const [selectedjobTitleName, setSelectedJobTitleName] = useState([])

      const fetch_job_type = async () => {
        await axios
          .get(`${newHost}portal/job_titles`, {
            headers:{Authorization: token}
          })
          .then((response) => {
            setjobtitles(response.data.data.job_titles);
          })
          .catch((error) => {
            console.log(error, "job");
          });
      };
      const getLicenseTypes = async ()=>{
        try {
          const response = await axios.get(`${newHost}license_types`,{
            headers : {Authorization: token}
          })
               console.log(response);
               setLicenseTypes(response.data.data.license_types)
        } catch (error) {
          console.log(error);
          
        }
      }
      
      const getLicenseStatus = async ()=>{
        try {
          const response = await axios.get(`${newHost}license_statuses`,{
            headers:{Authorization: token}
          })
               console.log(response);
               setLicenseStatus(response.data.data.license_statuses)
        } catch (error) {
          console.log(error);
          
        }
      }
      const getStaffStatus = async ()=>{
        try {
          const response = await axios.get(`${newHost}portal/status`,{ 
            headers : {Authorization : token}
          })
               console.log(response);
               setStaffStatus(response.data.data.stuff_statuses)
        } catch (error) {
          console.log(error);
          
        }
      }
      useEffect(() => {
        fetch_job_type();
        getStaffStatus()
        getLicenseStatus()
        getLicenseTypes()
      }, []);
     
    
       // Form
          const {
            register,
            handleSubmit,
            formState: { errors},
            setValue: setStaffValue,
            control,
            reset
          } =useForm({
      shouldUnregister: true,   
      defaultValues: {
        profile_photo: null,
        license_photo: null,
        job_title_ids: [],
        first_name: "",
        last_name: "",
        username: "",
        birth_date: null,
        phone_number: "",
        joined_at: null,
        gender: "",
        email: "",
        password: "",
        password_confirmation: "",
        status: "",
        license_type_id: "",
        expired_date: null,
        renewal_date: null,
        license_status: ""
      }
    });
      
     useEffect(() => {
     if (staffDetails) {
       reset({
         first_name: staffDetails.first_name || "",
         last_name: staffDetails.last_name || "",
         username: staffDetails.username || "",
         email: staffDetails.email || "",
         phone_number: staffDetails.phone_number || "",
         gender: staffDetails.gender || null,
         status: staffDetails.status || null,
         job_title_ids: staffDetails?.job_titles?.map(j => j.id),
   
         joined_at: staffDetails.joined_at
           ? dayjs(staffDetails.joined_at)
           : null,
   
         birth_date: staffDetails.birth_date
           ? dayjs(staffDetails.birth_date)
           : null,
   
         renewal_date: staffDetails.driver_license?.renewal_date
           ? dayjs(staffDetails.driver_license?.renewal_date)
           : null,
   
         expired_date: staffDetails.driver_license?.expired_date
           ? dayjs(staffDetails.driver_license?.expired_date)
           : null,
   
         license_type_id: staffDetails.driver_license?.license_type_id || null,
         license_number: staffDetails.driver_license?.license_number || null,
         license_status: staffDetails.driver_license?.status || null,
       });
     }
   }, [staffDetails, reset]);
  return ( 
<>
   <Modal show={show} onHide={handleClose} dialogClassName="custom-staff-modal-size">
      <Modal.Header className="">
        <Modal.Title className="">Update Staff</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="my-3">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="d-flex justify-content-center">
              <label htmlFor="profile_photo" className="">
                <div style={{ width: "100px", height: "100px", borderRadius: "50%", border: "dashed 1px #C6C6C6" }} className=" p-4 position-relative">

                  <div style={{ width: "", height: "" }} className="">
                    <img
                      className="w-100"

                      src={
                        imagePreview
                          ? imagePreview
                          :
                          defaultImage
                      }
                      alt="profile_photo"
                    />
                  </div>


                  <input onChange={FileChange} type="file" id="profile_photo" className="d-none " />
                  {imagePreview ? null : <img className="cameraIconUploading" src={cameraIcon} alt="" />}
                </div>
              </label>




            </div>


            <div className="row my-2">
              <div className="col-md-6">
                <label htmlFor="first_name">First Name</label>
                <TextField  {...register("first_name",
                   {required:"First name is required"}
                  )} 
                   className="w-100 m-0" type="text" size="small" id="first_name" placeholder="Enter First Name" error={!!errors.first_name} />
                  {errors?.first_name && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.first_name?.message}
                    </p>
                  )}
              </div>
              <div className="col-md-6">
                <label htmlFor="last_name">Last Name</label>
                <TextField {...register("last_name",
                {required:"Last name is required"}

                )} className="w-100 m-0" type="text" size="small" id="last_name" placeholder="Enter Last Name" error={!!errors.last_name} />
                  {errors?.last_name && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.last_name?.message}
                    </p>
                  )}
              </div>
            </div>
            <div className="row my-2">
              <div className="col-md-6 remove-date-space">
                <label htmlFor="joined_at">Join on</label>
                <LocalizationProvider


                  dateAdapter={AdapterDayjs}>
                  <DemoContainer

              
                    components={["DatePicker"]}

                  >
                    <Controller
                    rules={{required:"Join at is required"}}
                      name="joined_at"
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                         className="m-0 w-100"
                          slotProps={{ textField: { size: 'small',} }}

                          {...field}
                          value={field.value}
                          onChange={(date) => field.onChange(date)}

                        />
                      )}
                      
                    />
                   
                  </DemoContainer>
                </LocalizationProvider>      
                   {errors?.joined_at && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.joined_at?.message}
                    </p>
                  )}
                      </div>
              <div className="col-md-6">
                <label htmlFor="phone_number">Mobile number</label>
                <TextField {...register("phone_number" ,
                  {required:"Phone Number is required"}
                  )} className="w-100 m-0" type="text" size="small" id="phone_number" placeholder="Enter Mobile number" error={!!errors.phone_number} />
                   {errors?.phone_number && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.phone_number?.message}
                    </p>
                  )}
              </div>
            </div>
            <div className="row my-2">
              <div className="col-md-6 remove-date-space">
                <label htmlFor="birth_date">Birth Date</label>
                <LocalizationProvider

                  dateAdapter={AdapterDayjs}>
                  <DemoContainer

                    components={["DatePicker"]}

                  >
                    <Controller
                    rules={{required:"Birth date is required"}}
                      name="birth_date"
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                        className="m-0 w-100"
                          slotProps={{ textField: { size: 'small', } }}

                          {...field}
                          value={field.value}
                          onChange={(date) => field.onChange(date)}

                        />
                      )}
                    />
                  </DemoContainer>
                </LocalizationProvider>
                   {errors?.birth_date && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.birth_date?.message}
                    </p>
                  )}
              </div>
              <div className=" col-md-6">
                <label htmlFor="gender">Gender</label>
                <Controller
                  name="gender"
                  control={control}
                   rules={{required:"Gender is required"}}
                      render={({ field }) => {
                      const options = gender.map(option => ({
                        label: option,
                        id: option,
                      }));

                      return (
                        <Autocomplete
                          size="small"
                          options={options}
                          value={options.find(opt => opt.id == field.value) || null}

                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}

                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}

                          renderInput={(params) => (
                            <TextField {...params} placeholder="Select Gender" className="m-0"
                             error={!!errors.gender}
                            />
                          )}
                        />
                      );
                    }}
           
                  />
             {errors?.gender && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.gender?.message}
                    </p>
                  )}
              </div>
            </div>
            <div className="row my-2">
              <div className="col-md-6">
                <label htmlFor="username">Username</label>
                <TextField {...register("username", 
                  {required:"Username is required"}
                  )} className="w-100 m-0" type="text" size="small" id="username" placeholder="Enter Username" error={!!errors.username} />
                  {errors?.username && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.username?.message}
                    </p>
                  )}
              </div>
              <div className="col-md-6">
                <label htmlFor="email">Email</label>
                <TextField  {...register("email",
                  {required: "Email is required"}
                  )} className="w-100 m-0" type="text" size="small" id="email" placeholder="Enter Email" error={!!errors.email} />
                  {errors?.email && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.email?.message}
                    </p>
                  )}
              </div>
            </div>
         
         
            <div className="row my-3">
              <div className="col-md-6">
                <label htmlFor="status">Status</label>
             <Controller
            rules={{required:"Status is required"}} 
              name="status"
              control={control}
              render={({ field }) => {
                const options = Object.entries(staffStatus).map(([key, value]) => ({
                  id: key,
                  label: value,
                }));

                return (
                  <Autocomplete
                    size="small"
                    options={options}
                    value={options.find(opt => opt.id == field.value) || null}

                    onChange={(e, item) => {
                      field.onChange(item ? item.id : null);
                    }}

                    renderOption={(props, option) => (
                      <li {...props} className="p-2">
                        {option.label}
                      </li>
                    )}

                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className="m-0"
                        placeholder="Select Status"
                        error={!!errors.status}
                      />
                    )}
                  />
                );
              }}
/>

            {errors?.status && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.status?.message}
                    </p>
                  )}
              </div>
              <div className=" col-md-6">
                <label htmlFor="job_title_id">Job Title</label>
            <Controller
  name="job_title_ids"
  control={control}
  rules={{ required: "Job title is required" }}
  defaultValue={[]}
  render={({ field }) => {
    const options = jobTitles.map(j => ({
      label: j.title,
      id: j.id,
    }));

    return (
      <Autocomplete
        multiple
        disableCloseOnSelect
        size="small"
        options={options}
        value={options.filter(opt =>
          field.value.includes(opt.id)
        )}
        onChange={(e, newValue) => {
          const ids = newValue.map(v => v.id);
          const titles = newValue.map(v => v.label);

          field.onChange(ids);
          setSelectedJobTitleName(titles);
        }}
        getOptionLabel={(option) => option.label}
     renderTags={(value, getTagProps) =>
       value.map((option, index) => 
        { const tagProps = getTagProps({ index }); return ( <span {...tagProps} key={option.id} className="d-flex align-items-center mx-1" style={{ padding: "2px 6px", borderRadius: "12px", backgroundColor: "#e0e0e0", fontSize: "0.8rem", display: "flex", alignItems: "center", gap: "6px", }} > <span>{option.label}</span> <span onClick={tagProps.onDelete} style={{ cursor: "pointer", fontSize: "12px", lineHeight: 1, color: "#555", }} > <Close sx={{ color: "red", fontSize: "16px" }} /> </span> </span> ); })}
     renderOption={(props, option, state) => ( <li {...props} className="custom-menu-item" style={{ padding: "10px 12px", display: "flex", alignItems: "center", gap: "10px", margin: "5px", backgroundColor: state.selected ? "rgba(193, 203, 213, 0.15)" : state.hovered ? "rgba(175, 175, 175, 0.06)" : "transparent", borderRadius: "6px", }} > <div className="label-size m-0">{option.label}</div> </li> )} ListboxProps={{ style: { maxHeight: 220, overflowY: "auto", padding: "6px", }, }}
        renderInput={(params) => (
          <TextField {...params} placeholder="Select Job title" />
        )}
      />
    );
  }}
/>


               {errors?.job_title_ids && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.job_title_ids?.message}
                    </p>
                  )}
              </div>
            </div>
            {selectedjobTitleName?.includes("Driver") ?
              <>
                <div className="my-2">
                  <div className="row my-2 align-items-center">
                    <div className="col-md-3">
                      <p className="label-size  main-text-color m-0">Driver License Info</p>
                    </div>
                    <div style={{ border: "1px solid #D8D8D8", height: 0 }} className="col-md-9"></div>
                  </div>
                  <div className="row my-2">
                    <div className="col-md-6">
                      <label htmlFor="license_number">License Number</label>
                      <TextField {...register("license_number",
                        {required:"License number is required"}
                        )} className="w-100 m-0" type="text" size="small" id="license_number" placeholder="Add license number" error={!!errors.license_number} />
                        {errors?.license_number && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.license_number?.message}
                    </p>
                  )}
                    </div>
                    <div className=" col-md-6">
                      <label htmlFor="license_type_id">License Type</label>
                      <Controller
                      rules={{required:"License Type"}}
                        name="license_type_id"
                        control={control}

                      render={({ field }) => {
                      const options = licenseTypes.map(option => ({
                        label: option.name,
                        id: option.id,
                      }));

                      return (
                        <Autocomplete
                          size="small"
                          options={options}
                          value={options.find(opt => opt.id == field.value) || null}

                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}

                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}

                          renderInput={(params) => (
                            <TextField className="m-0" {...params} placeholder="Select License"
                              error={!!errors?.license_type_id}

                            />
                          )}
                        />
                      );
                    }}
                        />
                          {errors?.license_type_id && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.license_type_id?.message}
                    </p>
                  )}

                    </div>
                  </div>
                  <div className="row my-2">
                    <div className="col-md-6 remove-date-space">
                      <label htmlFor="renewal_date">Renewal date</label>
                      <LocalizationProvider

                        dateAdapter={AdapterDayjs}>
                        <DemoContainer


                                
                          components={["DatePicker"]}

                        >
                          <Controller
                          rules={{required:"Renewal Date is required"}}
                            name="renewal_date"
                            control={control}
                            render={({ field, fieldState }) => (
                              <DatePicker
                              className="m-0 w-100"
                                slotProps={{ textField: { size: 'small', } }}

                                {...field}
                                value={field.value}
                                onChange={(date) => field.onChange(date)}

                              />
                            )}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                         {errors?.renewal_date && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.renewal_date?.message}
                    </p>
                  )}
                                    </div>
                    <div className="col-md-6 remove-date-space">
                      <label htmlFor="expired_date">Expiration date</label>
                      <LocalizationProvider

                        dateAdapter={AdapterDayjs}>
                        <DemoContainer



                          components={["DatePicker"]}

                        >
                          <Controller
                          rules={{required:"Expiration Date is required"}}
                            name="expired_date"
                            control={control}
                            render={({ field, }) => (
                              <DatePicker
                              className="m-0 w-100"
                                slotProps={{ textField: { size: 'small', } }}

                                {...field}
                                value={field.value}
                                onChange={(date) => field.onChange(date)}

                              />
                            )}
                          />
                        </DemoContainer>
                      </LocalizationProvider>      
                         {errors?.expired_date && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.expired_date?.message}
                    </p>
                  )}
                              </div>
                  </div>
                  <div className="row my-2">
                    <div className=" col-md-12">
                      <label htmlFor="license_status">License Status</label>
                      <Controller
                        rules={{required:"License status is required"}}
                        name="license_status"
                        control={control}

                       render={({ field }) => {
                      const options = licenseStatus.map(option => ({
                        label: option,
                        id: option,
                      }));

                      return (
                        <Autocomplete
                          size="small"
                          options={options}
                          value={options.find(opt => opt.id == field.value) || null}

                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}

                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}

                          renderInput={(params) => (
                            <TextField {...params} placeholder="Select License Status" className="m-0"
                             error={!!errors.license_status}
                            />
                          )}
                        />
                      );
                    }}
                         />
                     {errors?.license_status && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.license_status?.message}
                    </p>
                  )}
                    </div>
                  </div>
                  <div className="row my-2">
                    <div className="col-md-12">
                      <label className="label-size main-text-color w-100" htmlFor="license_photo">
                        License Image <span className="text-danger">*</span>
                        <div style={{ border: "dashed 1px #C6C6C6" }} className="p-4 d-flex justify-content-center">
                          <div style={{ width: "150px", height: "80px" }} className="text-center">
                            <img className={`${imageLicensePreview ? "w-100 h-100" : "w-50 h-50"}`} src={imageLicensePreview ? imageLicensePreview : cameraIcon} alt="" />
                            {imageLicensePreview ? null : <p className="main-text-color m-0">Add Image</p>}
                          </div>
                        </div>
               
<Controller
  name="license_photo"
  control={control}
  defaultValue={null}
  rules={{
    validate: (value) => {
      if (imageLicensePreview) return true;

      if (value instanceof File) return true;

      return "License image is required";
    },
  }}
  render={({ field }) => (
    <input
      type="file"
      id="license_photo"
      className="d-none"
      onChange={(e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
          setImageLicensePreview(reader.result);
          field.onChange(file);
        };
        reader.readAsDataURL(file);
      }}
    />
  )}
/>





                      </label>
                        {errors?.license_photo && (
                    <p style={{ fontSize: "13px" }} className="text-danger my-1 fw-semibold text-center">
                      {errors?.license_photo?.message}
                    </p>
                  )}
                    </div>
                  </div>
                </div>
              </>
              : null}
                <div className="d-flex gap-3 justify-content-center align-items-center my-3 input-group-responsive">
              <button type="submit" className="btn btn-dark px-5">Save</button>
              <button type="reset" onClick={handleClose} className="btn btn-light px-5">Cancel</button>
            </div>

          </form>
        </div>

      </Modal.Body>
    </Modal>
  <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={`Are you sure you want to delete this note? Confirm to proceed or cancel to keep it.`}
        deleteFunction={deleteStaffNote}
      />
        <DeleteModal
              showDelete={showExpenseDelete}
              handleDeleteClose={handleExapenseDeleteClose}
              textMessage={`Are you sure you want to delete Exp-${expenseId}? Confirm to proceed or cancel to keep them.`}
              deleteFunction={deleteExpense}
            />
        <DeleteModal
              showDelete={showDeleteRole}
              handleDeleteClose={handleDeleteRoleClose}
              textMessage={`Are you sure you want to delete this role from the staff.`}
              deleteFunction={deleteStaffRole}
            />
  <Modal show={Othershow} onHide={handleOtherClose} dialogClassName="custom-size-Equipment-modal">
            <Modal.Header>
              <Modal.Title className="text-black  fs-6">
              Other Equipment Management Permissions (Read Only)
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{}}>
              <div className="other-prem">
                <div className="d-flex justify-content-between mx-4 my-2">
                 <div className="d-flex gap-1">
                  
                   <input readOnly checked disabled type="checkbox" />
                   <h6>1. Assign to Service</h6>
                 </div>
                 
                 <div className="d-flex gap-1">
                  <input readOnly checked disabled type="checkbox" />
                   <h6>2. Approve Request</h6>
                 </div>
                 
                </div>
                <div className="d-flex justify-content-between mx-4 my-2">
                  <div className="d-flex gap-1">
                  
                   <input readOnly disabled type="checkbox" />
                   <h6>3. Assign to Service</h6>
                 </div>
                 
                 <div className="d-flex gap-1">
                  <input readOnly checked disabled type="checkbox" />
                   <h6>4. Approve Request</h6>
                 </div>
                </div>
                <div className="d-flex justify-content-between mx-4 my-2">
                 <div className="d-flex gap-1">
                  
                   <input readOnly disabled type="checkbox" />
                   <h6>5. Assign to Service</h6>
                 </div>
                 
                 <div className="d-flex gap-1">
                  <input readOnly disabled type="checkbox" />
                   <h6>6. Approve Request</h6>
                 </div>
                 
                </div>
                <div className="d-flex justify-content-between mx-4 my-2">
                  <div className="d-flex gap-1">
                  
                   <input readOnly disabled type="checkbox" />
                   <h6>7. Assign to Service</h6>
                 </div>
                 
                 <div className="d-flex gap-1">
                  <input readOnly disabled  type="checkbox" />
                   <h6>8. Approve Request</h6>
                 </div>
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-center custom-card-sm my-3">
                              <button type="reset" onClick={handleOtherClose} className="btn btn-dark px-5">Close</button>
                            </div>
            </Modal.Body>
          </Modal>

     <Modal show={showReviewDetails} onHide={handleReviewDetailsModalClose} dialogClassName='custom-review-modal-size'>
                            <Modal.Header closeButton>
                                <Modal.Title className='m-0 w-100'>
                                  <div className="d-flex gap-5 align-items-center  w-100">
                                    <div className="">
                                       <h6 className="m-0">Details invoice # {expenseDetails?.id}</h6>
                                    </div>
                                   
                                     <div className="">
                           <Autocomplete
                        disablePortal
                        options={expensesStatuses.map((item) => ({
                          label: item.key,
                          id: item.value,
                          icon: item.icon,
                        }))}
                        sx={{ width: "150px" }}
                        value={updateStatus.status}
                        renderOption={(props, option) => (
                          <li {...props} className="px-3 py-2 d-flex gap-3">
                            <img src={option.icon} alt="" />
                            <div className="label-size m-0">{option.label}</div>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField className="m-0" {...params} />
                        )}
                        onChange={(event, newValue) => {
                          setUpdateStatus((prev) => ({
                            ...prev,
                            status: newValue,
                          }));
                        }}
    />
    
                                     </div>
                                  </div>
                             <h6 className="main-text-color">{new Date (expenseDetails?.created_at).toLocaleDateString()}</h6>
        
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                               <div className="row">
                                  <div className="col-md-9 col-12">
                                    <div className="row">
                                                      <div className="col-12 col-md-4">
                                                        <div className="mx-4">
                                                          <h6 style={{
                                                            fontSize: "14px"
                                                          }} className="main-text-color ">Van ID</h6>
                                                            <h6 className="my-3 fw-semibold">
                                                              Van # {expenseDetails?.van_id}
                                                            </h6>
                                                        </div>
                                                      </div>
                                                      <div className="col-12 col-md-4">
                                                        <h6 style={{
                                                          fontSize: "14px"
                                                        }} className="main-text-color ">Type</h6>
                                                        <h6 className="my-3">{expenseDetails?.expense_type}</h6>
                                                      </div>
                                                      <div className="col-12 col-md-4">
                                                        <h6 style={{
                                                          fontSize: "14px"
                                                        }} className="main-text-color ">Amount</h6>
                                                        <h6 className="my-3">{`${Number(expenseDetails?.amount)?.toLocaleString("en-US")} EGP`}</h6>
                                                      </div>
                                                      
                                                    </div>
                                                    <div className="row mx-2">
                                                      <div className="col-12">
                                                        <h6 style={{
                                                          fontSize: "14px"
                                                        }} className="main-text-color ">Description</h6>
                                                        <h6 className="my-3">{expenseDetails?.notes}</h6>
                                                      </div>
                                                      {activeImage &&
                 <div className="position-relative ">
                  <img
                    src={activeImage?.full_image_url}
                    alt="invoice"
                    className="w-100"
                    style={{ height: "", objectFit: "fill" }}
                  />
        
                  <button
                    onClick={handleDownload}
                    className="btn  position-absolute"
                    style={{ bottom: "0px", left: "0px", backgroundColor:"rgba(0, 0, 0, 0.6)",color:"#FFF1F1" }}
                  >
                    <SaveAlt fontSize='small'/> Download
                  </button>
                </div>
                                                      
                                                      }
            
                                                    </div>
                                  </div>
                                  <div className="col-md-3">
                      {expenseDetails?.images?.length > 0 ? expenseDetails?.images?.map((img) => (
                  <div
                    key={img?.id}
                    className={`border rounded-3 p-1 my-3 ${
                      activeImage?.id == img?.id ? "border-dark border-4" : ""
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => setActiveImage(img)}
                  >
                    <img
                      src={img?.full_image_url}
                      alt="thumb"
                      className="w-100"
                      style={{ height: "120px", objectFit: "fill" }}
                    />
                  </div>
                )) : null}
                                  </div>
                               </div>
                               {updateStatus.status?.id == "deducted" &&
                                  <div className="my-3">
                                <label className='main-text-color' htmlFor="">Estbn Notes <span className='text-danger'>*</span></label>
                                        <textarea
                                className="w-100 my-1"
                                style={{ padding: 10, borderRadius: 5, border: "solid 2px #D8D8D8", }}
                                rows={3}
                                placeholder="Add notes.."
                                onChange={(e) =>
                                setUpdateStatus({
                                  ...updateStatus,
                                  notes: e.target.value
                                })
                                }
                              />
                               </div>
                               }
                            
                               <div className="mt-4 ">
                                 <button onClick={handleUpdateStatus} className='btn btn-dark w-100'>Save</button>
                               </div>
                            </Modal.Body>
                        </Modal>
     <Modal show={showRole} onHide={handleRoleModalClose} dialogClassName='custom-review-modal-size'>
                    <Modal.Header>
                        <Modal.Title className='m-0 w-100 d-flex justify-content-between align-items-center'>
                         <div className="">
                          <h4 className="fw-semibold m-0">Add Roles</h4>
                         </div>
                         <div className="w-50">
                           <div
                                            className="input-group flex-nowrap  justify-content-end align-items-center rounded-2  "
                                          >
                                            <input
                                              type="text"
                                              className={
                                                "form-control  bg-transparent position-relative rounded "
                                              }
                                              placeholder={"Search"}
                                              aria-label="Username"
                                              aria-describedby="addon-wrapping"
                                             value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            />
                                             <div className="position-absolute mx-2">
                                              <Search/>
                                             </div>
                                            
                                          </div>
                         </div>

                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                   <div className="my-4 ">
                    {filteredRoles.map((role,index)=>
                    <>
                     <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <FormControlLabel
                          control={
                            <Checkbox
                            disableRipple
                            checked={selectedRoleIds.includes(role.id)}
  onChange={(e) => {
    if (e.target.checked) {
      setSelectedRoleIds(prev => [...prev, role.id]);
    } else {
      setSelectedRoleIds(prev =>
        prev.filter(id => id !== role.id)
      );
    }
  }}
                            size='large'
                           sx={{"&.Mui-checked":{
                            color:"black"
                           }}}
                            />
                          }
                          label={
                            <div className="">
                              <p className='m-0 fw-semibold'>{`${index + 1}. ${role.name}`}</p>
                            </div>
                          }
                         
                        />
                     
                    </div>
                    <div className="">
                      <p className="main-text-color m-0 label-size">{`${role.permissions_count} permissions`}</p>
                    </div>
                  </div>
                    </>
                    )}
                 
                  {/* <div className="d-flex justify-content-between align-items-center ">
                      <div className="d-flex align-items-center">
                        <FormControlLabel
                          control={
                            <Checkbox
                            disableRipple
                            
                            size='large'
                           sx={{"&.Mui-checked":{
                            color:"black"
                           }}}
                            />
                          }
                          label={
                            <div className="">
                              <p className='m-0 fw-semibold'>2. Admin</p>
                            </div>
                          }
                         
                        />
                     
                    </div>
                    <div className="">
                      <p className="main-text-color m-0 label-size">150 permissions</p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center my1">
                      <div className="d-flex align-items-center">
                        <FormControlLabel
                          control={
                            <Checkbox
                            disableRipple
                            
                            size='large'
                           sx={{"&.Mui-checked":{
                            color:"black"
                           }}}
                            />
                          }
                          label={
                            <div className="">
                              <p className='m-0 fw-semibold'>3. Super Admin</p>
                            </div>
                          }
                         
                        />
                     
                    </div>
                    <div className="">
                      <p className="main-text-color m-0 label-size">150 permissions</p>
                    </div>
                  </div> */}
                      <div className="d-flex justify-content-center align-items-center gap-3 mt-5">
                        <button className='btn btn-light main-text-color px-5'>Cancel</button>
                        <button onClick={handleSubmitRoles} className='btn btn-dark px-5'>Save</button>
                      </div>
                   </div>
                    </Modal.Body>
                </Modal>
     <Modal show={showPermissionView} onHide={handlePermissionViewClose} dialogClassName='custom-permission-modal-size'>
                    <Modal.Header>
                        <Modal.Title className='m-0 w-100 d-flex justify-content-between align-items-center'>
                         <div className="">
                          <h6 className="fw-semibold m-0">Permissions Overview (Read Only)</h6>
                         </div>
                         <div className="w-50">
                           <div
                                            className="input-group flex-nowrap  justify-content-end align-items-center rounded-2  "
                                          >
                                            <input
                                              type="text"
                                              className={
                                                "form-control  bg-transparent position-relative rounded "
                                              }
                                              placeholder={"Search"}
                                              aria-label="Username"
                                              aria-describedby="addon-wrapping"
                                            />
                                             <div className="position-absolute mx-2">
                                              <Search/>
                                             </div>
                                            
                                          </div>
                         </div>

                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                   <div className="my-4 ">
               <form>
           
              
              
<div className="permissions-grid-container">
      {/* Header */}
      <div className="permissions-header">
        <div className="col category-col ">Category</div>
        {permissionsList.map((perm) => (
          <div key={perm} className="col perm-col">
            {perm}
          </div>
        ))}
      </div>

      {/* Body */}
      {permissionsData.map((group, index) => (
        <div key={group.category} className="permissions-group">
          {/* Main Category Row */}
          <div className="permissions-row main-category">
            <div className="col category-col">
              <button
                className="expand-btn"
                onClick={() => handleToggleExpand(index)}
              >
                {expanded === index ? <ExpandLessIcon/> : <ExpandMoreIcon/> }
              </button>
              <h6 className="m-0">{group.category}</h6>
            </div>

            {permissionsList.map((perm) => (
              <div key={perm} className="col perm-col">
                <input
                  disabled
                  readOnly
                  type="checkbox"
                  checked={checked}
                  // onChange={() =>
                  //   handleCheckboxChange(group.category, "main", perm)
                  // }
                />
              </div>
            ))}
          </div>
          

          {/* Subcategories */}
          {expanded === index &&
            group.subcategories.map((sub) => (
              <div key={sub} className="permissions-row sub-category">
                <div className="col category-col sub-cat">
                  {sub}
                </div>

                {permissionsList.map((perm) => (
                  <div key={perm} className="col perm-col">
                    <input
                      type="checkbox"
                      readOnly
                      disabled
                     
                    />
                  </div>
                ))}
              </div>
            ))}

          {expanded === index && (
            <div className="view-more">
              <button onClick={handleOtherShow}>View Other Permissions →</button>
            </div>
          )}
        </div>
      ))}
    </div>


                <div className="d-flex justify-content-center align-items-center custom-card-sm my-3">
                              <button type="reset" onClick={handlePermissionViewClose} className="btn btn-dark px-5">Close</button>
                            </div>
          </form>
                   </div>
                    </Modal.Body>
                </Modal>
     <Modal show={showNoteModal} onHide={handleNoteModalClose} dialogClassName=''>
                    <Modal.Header closeButton>
                        <Modal.Title className='m-0 w-100'>
                         Add Note

                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                   <div className="my-4">
                    <form onSubmit={handleSubmitNotes(submitStaffNotes)}>
                      <div className="">
                        <label htmlFor="title">Title</label>
                        <TextField {...registerNotes("title")} id='title' type='text' size='small' className='w-100' placeholder="Add note title"/>
                      </div>
                      <div className="my-1">
                        <label htmlFor="note-content">Note Content</label>
                        <textarea
                        {...registerNotes("content")}
                        id='note-content'
                        className="w-100 my-1"
                        style={{ padding: 10, borderRadius: 5, border: "solid 2px #D8D8D8", }}
                        rows={3}
                        placeholder="Add note content"
                
                      />
                      </div>
                      <div className="d-flex justify-content-center align-items-center gap-3 mt-5">
                        <button type='reset' onClick={handleNoteModalClose} className='btn btn-light main-text-color px-5'>Cancel</button>
                        <button className='btn btn-dark px-5'>Save</button>
                      </div>

                    </form>
                   </div>
                    </Modal.Body>
                </Modal>
     <Modal show={showReviewNoteModal} onHide={handleReviewNoteModalClose} dialogClassName='green-border custom-review-modal-size'>
                    <Modal.Header closeButton>
                        <Modal.Title className='m-0 w-100'>
                         Note # {noteStaffDetails?.id}

                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                   <div className="">
                   <h6 className="fw-bold ">{noteStaffDetails?.note?.title}</h6>
                   <p className="fw-semibold label-size">{noteStaffDetails?.note?.notes}
</p>
                   </div>
                   <div className="d-flex gap-5 align-items-center label-size">
                      <p className="">{`Created at:  ${new Date (noteStaffDetails?.created_at).toLocaleDateString()} ${new Date(noteStaffDetails?.created_at).toLocaleTimeString()}`}</p>
                      <p className="">{`Created by: ${noteStaffDetails?.note?.created_by?.name}`}</p>
                   </div>
                    </Modal.Body>
                </Modal>
 
<div className="m-4 ">
    <div className="row min-vh-100">
        <div className="col-lg-3 col-md-12 col-sm-12">
            <div className="my-4 px-2 py-3">
              <h5 className="fw-semibold">Technical Profile</h5>
              <div className="mx-1 my-2">
               <div className="">
                  <div className="driver-section-responsive linear-back-color border rounded-2 p-3  w-100 my-4">
                   <div style={{top:"30px", }} className="position-relative w-100 driver-section-info">
                    <img style={{width:"40%"}} className='' src={staffData?.profile_photo_path? `${newImageUrl}${staffData.profile_photo_path}` : defultImage} alt="staff-image" />
                  
                </div>  
             </div>
                   <div className="mt-5 d-flex justify-content-between align-items-center">
                   <h4 className='fw-bold m-0'>{staffData?.name}</h4>
                      <IconButton onClick={()=>handleUpdateStaff(staffData)} disableRipple  size='small' >
                        <EditOutlinedIcon  sx={{width:"35px", height:"35px", border:"1px solid #F0F0F0", p:"5px", borderRadius:"50%"}}/>
                      </IconButton>
                    </div>
               </div>
                <div className="my-3 border-bottom">
                  <div className="">
                    <h6 className="">{staffData.job_titles?.map((job)=>
                     `${job?.title}, `
                    )}</h6>
                  </div>
                      <div className="my-1 d-flex justify-content-between align-items-center driver-info">
                      <div className="d-flex gap-2 align-items-center driver-info ">
                         <EventAvailableIcon fontSize='small' sx={{color:"#535353"}}/>
                        <h6 className="main-text-color m-0">{`Joined on ${new Date(staffData.joined_at).toLocaleDateString()}`}</h6>
                      </div>
                    </div>
                    <div className="my-3 d-flex justify-content-between align-items-center driver-info">
                      <div className="d-flex gap-2 align-items-center driver-info">
                         <LocalPhoneOutlinedIcon fontSize='small' sx={{color:"#535353"}} className='reverse-direction-icon' />
                        <h6 className="main-text-color label-size m-0">{staffData?.phone_number}</h6>
                      </div>
                    </div>
                    <div className="my-3 d-flex justify-content-between align-items-center driver-info">
                      <div className="d-flex gap-2 align-items-center driver-info">
                         <CakeOutlinedIcon fontSize='small' sx={{color:"#535353"}} />
                        <h6 className="main-text-color m-0">{new Date (staffData?.birth_date).toLocaleDateString()}</h6>
                      </div>
                    </div> 
                    <div className="my-3 d-flex justify-content-between align-items-center driver-info">
                      <div className="d-flex gap-2 align-items-center driver-info">
                         <PersonOutlinedIcon fontSize='small' sx={{color:"#535353"}} />
                        <h6 className="main-text-color m-0">{staffData?.gender}</h6>
                      </div>
                    </div> 
                   
                    <div className="my-3 d-flex justify-content-between align-items-center driver-info">
                      <div className="d-flex gap-2 align-items-center driver-info">
                         <BadgeOutlinedIcon fontSize='small' sx={{color:"#535353"}} />
                        <h6 className="main-text-color m-0">{staffData?.username}</h6>
                      </div>
                    </div> 
                    <div className="my-3 d-flex justify-content-between align-items-center driver-info">
                      <div className="d-flex gap-2 align-items-center driver-info">
                         <EmailOutlinedIcon fontSize='small' sx={{color:"#535353"}} />
                        <h6 className="main-text-color m-0">{staffData.email}</h6>
                      </div>
                    </div> 
                    <div className="my-3 d-flex justify-content-between align-items-center driver-info">
                      <div className="d-flex gap-2 align-items-center driver-info">
                         <InfoOutlinedIcon fontSize='small' sx={{color:"#535353"}} />
                        <h6 className="main-text-color m-0">{staffData.status}</h6>
                      </div>
                    </div> 
                </div>
                 <div className="my-4">
                  <div className="">
                      <h5 style={{color:"#4A4A4A"}} className='m-0 fw-semibold'>Agent Info</h5>
                      </div>
                    
                   <div className="my-3">
                      <div className="my-2 d-flex justify-content-between align-items-center driver-info">
                      <div className="d-flex gap-2 align-items-center driver-info ">
                         <StarOutlinedIcon sx={{color:"#FFC400" , fontSize:"16px"}}/>
                        <h6 className="main-text-color m-0">4.8 rates </h6>
                      </div>
                    </div>
                      <div className="my-2 d-flex justify-content-between align-items-center driver-info">
                      <div className="d-flex gap-2 align-items-center driver-info ">
                         <CircleIcon  sx={{color:"#18AB00", fontSize:"12px"}}/>
                        <h6 className="main-text-color m-0">Last activity : 2 July 2024 at 04:30 PM</h6>
                      </div>
                    </div>
                   </div>
                 </div>
              </div>
            </div>
        </div>
        <div className="col-lg-9 col-md-12 col-sm-12">
             <div className="d-flex justify-content-start align-items-center my-4">
      
                  <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => setValue(newValue)}
        sx={{
          backgroundColor: {
            xs:"transparent",
            sm:"#f8f9fa"
          },
          height: "auto",
          padding: 1,
         borderRadius:{
          sm:"10px",
          xs:0
        
         },
          width:"100%",
          flexDirection: {
            xs: "column", 
            sm: "row",    
          },
          
           alignItems: {
            xs: "center",
          }
            ,
          ".MuiBottomNavigationAction-root": {
            fontSize: "20px",
            minWidth: 0,
            padding: "8px 12px",
            justifyContent: "center", 
            width: "100%",              
          },
          ".Mui-selected": {
            fontWeight: "bold",
          },
        }}
      >
        <BottomNavigationAction label="Orders" />
        <BottomNavigationAction label="Permissions" />
        <BottomNavigationAction label="Expenses" />
        <BottomNavigationAction label="Notes" />
        <BottomNavigationAction label="Client Reviews" />
        <BottomNavigationAction label="ESTBN Reviews" />
        <BottomNavigationAction label="Shifts" />
        
      </BottomNavigation>
    </Box>
              
             </div>
             {value == 0 ?
              <div className="border rounded-3 min-vh-100">
              <div className="m-3 p-3">
            <div className="d-flex align-items-center justify-content-start custom-card-sm ">
              <div className="date-remove-space  ">
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer
            
            
                                  components={["DatePicker"]}
            
                                >
                                  <DatePicker
                                    slotProps={{ textField: { size: 'small',placeholder:"Select Date" } }}
                                    onChange={(newValue) => setSelectedDate(newValue)}

                                    
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </div>
            

              </div>

                  <div className="">
        <div className="accordion mt-5" id="accordionPanelsStayOpenExample">
          {staffOrders.length > 0 ? staffOrders.map((order)=> 
               <div id={`accordion-${order.id}`} className="accordion-item my-3">
              <h2 className="accordion-header remove-border-focus" id="headingOne">
                <button
                  className="accordion-button collapsed bg-light text-dark btn-xs buttons"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse-${order.id}`}
                  aria-expanded="false"
                  aria-controls={`collapse-${order.id}`}

                >
                  <div className="row justify-content-between w-100"> 
                    <div className="col-8">
                      Order
                      <span className="fw-bold g-1 text-dark mx-2 my-0"># {order.id} </span>
                      <div className='mx-2 px-3 rounded-4 bg-white  my-0 d-inline-block align-items-center '>
                        <img style={{width:"30px" , height:"30px"}} src={order.order_status?.image_url? order.order_status?.image_url : defaultImage} alt="" className="service-icon" />
                        <span className='label-size'>{order.order_status?.label}</span>
                      </div>
                    </div>
                    <div className="col-4 d-flex justify-content-end align-items-center gap-1">
                      <span className="text-dark fw-bold mx-2 ">{`${Number(order.total)?.toLocaleString("en-Us")} EGP`}</span>
                        
                    </div>
                  </div>
                </button>
              </h2>
              <div
                id={`collapse-${order.id}`}
                className="accordion-collapse collapse"
                 data-bs-parent={`#accordion-${order.id}`}
              >
                <div  className="accordion-body ">
                  <div className="my-1">
                    {driverTrips.length > 0 && driverTrips.map((trip)=>
                      <div className="border-bottom">
                      <h6  className="label-size m-0 fw-semibold">Trip Details</h6>
                      <div className="row mt-3 mb-2">
                        <div className="col-md-6 d-flex align-items-center gap-2">
                          <h6 className='label-size m-0'>Trip Date:</h6>
                          <h6 className='label-size m-0'>
                            {new Date (order.scheduled_date)?.toLocaleDateString()}
                          </h6>
                        </div>
                        <div className="col-md-6 d-flex align-items-center gap-2">
                          <h6 className='label-size m-0'>Starting Point:</h6>
                          <h6 className='label-size m-0'>

                          </h6>
                        </div>
                      </div>
                      <div className="row my-2">
                        <div className="col-md-6 d-flex align-items-center gap-2">
                          <h6 className='label-size m-0'>Vehicle Name:</h6>
                          <h6 className='label-size m-0'>
                            
                          </h6>
                        </div>
                        <div className="col-md-6 d-flex align-items-center gap-2">
                          <h6 className='label-size m-0'>Start Time:</h6>
                          <h6 className='label-size m-0'>
                            {new Date (trip.started_at)?.toLocaleTimeString()} 
                          </h6>
                        </div>
                      </div>
                      <div className="row my-2">
                        <div className="col-md-6 d-flex align-items-center gap-2">
                          <h6 className='label-size m-0'>Vehicle Code:</h6>
                          <h6 className='label-size m-0'>
                            {trip.vehicle_id}
                          </h6>
                        </div>
                    
                        <div className="col-md-6 d-flex align-items-center gap-2">
                          <h6 className='label-size m-0'>End point:</h6>
                          <h6 className='label-size m-0'>
                            
                          </h6>
                        </div>
                    
                      </div>
                      <div className="row my-2">
                        <div className="col-md-6 d-flex align-items-center gap-2">
                          <h6 className='label-size m-0'>License Plate:</h6>
                          <h6 className='label-size m-0'>
                            
                          </h6>
                        </div>
                    
                        <div className="col-md-6 d-flex align-items-center gap-2">
                          <h6 className='label-size m-0'>End Time:</h6>
                          <h6 className='label-size m-0'>
                            {new Date (trip.ended_at)?.toLocaleTimeString()}
                          </h6>
                        </div>
                    
                      </div>
                    </div>
                  )
                    }
                    
                    <div className="border-bottom">
                      <h6  className="label-size my-2
                      
                      
                       fw-semibold">Order Details</h6>
                      <div className="row mt-3 mb-2">
                        <div className="col-md-6 d-flex align-items-center gap-2">
                          <h6 className='label-size m-0'>Order Date:</h6>
                          <h6 className='label-size m-0'>
                            {new Date (order.scheduled_date)?.toLocaleDateString()}
                          </h6>
                        </div>
                        <div className="col-md-6 d-flex align-items-center gap-2">
                          <h6 className='label-size m-0'>Time:</h6>
                          <h6 className='label-size m-0'>
                            {`${order.scheduled_from} - ${order.scheduled_to}`} 
                          </h6>
                        </div>
                      </div> 
                      <div className="row my-2">
                        <div className="col-md-6 d-flex align-items-center gap-2">
                          <h6 className='label-size m-0'>Car Model:</h6>
                          <h6 className='label-size m-0'>
                            {order.vehicle?.name}
                          </h6>
                        </div>
                        <div className="col-md-6 d-flex align-items-center gap-2">
                          <h6 className='label-size m-0'>Payment:</h6>
                          <h6 className='label-size m-0'>
                            {order.payment? order.payment?.method?.name_en : "-" } 
                          </h6>
                        </div>
                      </div>
                      <div className="row my-2">
                        <div className="col-md-6 d-flex align-items-center gap-2">
                          <h6 className='label-size m-0'>Address:</h6>
                          <h6 className='label-size m-0'>
                            {order?.address?.area}
                          </h6>
                        </div>
                    
                      </div>
                    </div>
                  
                    {order?.categories?.map((category)=>{
                  return(
                     <div className="border-bottom">
                    <div className="my-2">
                           <div className="d-flex justify-content-between align-items-center ">
                        <div className="d-flex align-items-center gap-2">
                         <img  style={{width:"35px", height:"35px"}} src={category.icon_url ? `${newImageUrl}${category.icon_url}` : defaultImage} alt="" />
                          <h6 style={{fontSize:"15px"}} className="m-0 fw-semibold">{`${category?.name}`}</h6>
                        </div>
                        <div className="fw-bold">{`${Number(category?.total_price)?.toLocaleString("en-Us")} EGP`}</div>
                      </div>
                      {category.subcategories?.filter((sub)=>sub.has_content).map((sub)=>
                    {
                       return( 
                   <>
                     <div className="d-flex justify-content-between align-items-center my-2 ">
                        <div className="label-van main-text-color">
                         {sub.name}
                        </div>
                        <div className="label-van">{`${Number(sub.total_price)?.toLocaleString("en-Us")} EGP`}</div>
                       
                      </div>

                      <div className="row">
            {sub.services.map((service)=>
                          service.variation?   
                          <div style={{gap:"5px"}} className="row">
                          {service.variation.property_values.map((item)=>
                             
                         item.property.is_general &&
                         <div className="col-md-4 d-flex gap-2">
                        <h6 className="label-van fw-semibold">{`${item.property.name}:`}</h6>
                        <h6 className="label-van fw-semibold">{`${item.value}`}</h6>
                         </div>
                       
                        
                          )}
                          </div>
                     :   
                     <div  className="col-md-4">
                         <div className=" d-flex gap-2">
                        <h6 className="label-van fw-semibold">{`${service.service_name}:`}</h6>
                        <h6 className="label-van fw-semibold">{`${Number(service.final_price)?.toLocaleString("en-Us")} EGP`}</h6>
                         </div>
                       
                        </div>
                       
                      )}

                      </div>
          
                   </>
                       )
                    }
                      
                  
                      )}
                      {/* <div className="d-flex justify-content-between align-items-center my-2 ">
                        <div className="label-van main-text-color">
                        Check Oil
                        </div>
                        <div className="label-van">1000 EGP</div>
                       
                      </div>
                      
                      <div className="d-flex justify-content-between align-items-center my-2 ">
                        <div className="label-van main-text-color">
                        Check Oil
                        </div>
                        <div className="label-van">1000 EGP</div>
                       
                      </div>
                       <div style={{gap:"100px"}} className="d-flex">
                         <div className="d-flex gap-2">
                        <h6 className="label-size fw-semibold">Oil Leak:</h6>
                        <h6 className="label-size fw-semibold">200.0 EGP</h6>
                         </div>
                         <div className="d-flex gap-2"> 
                          <h6 className="label-size fw-semibold">Check Engine oil:</h6>
                          <h6 className="label-size fw-semibold">200.0 EGP</h6>
                         </div>
                        </div> */}
                    </div>
                    </div>

                  )
                    })}
                 
                  </div>
      
                </div>
              </div>
            </div>  
        
        )
     
          
          : <div className="flex flex-column text-center rounded-3 p-2">

            <img src={noData} alt="no-data" />
            <p style={{ color: "#535353" }} className=''>No available orders!</p>
          </div>}
          
        
          </div>
    </div>
              </div>
             </div> 
             :
             value == 1? 
             <div className="border rounded-3 min-vh-100">
               <div className="mx-4 px-2 py-3">
                     <div className="d-flex justify-content-between align-items-center">
                  <h5 className="m-0 fw-semibold">Permissions</h5>
          <div className=''>  
<button onClick={handleRoleModalShow} className="btn btn-light">
<Add/>  Add Role
          </button>
          </div>
 
                </div>

                {staffRoles.map((role)=>{
                  return(
<>
    <div className="d-flex justify-content-between align-items-start  my-5">
          
                           <div className="">
             <h6 className='fw-semibold'>{role.role?.name}</h6>
             {role.role?.permissions.map((permission)=>
             <p className="main-text-color my-3">{permission.name}</p>
            )}
             
                     </div>
                      
                    
                     <div className="d-flex gap-2 align-items-start">
                       <IconButton onClick={()=>handlePermissionViewShow(role?.role?.id)} disableRipple size='small' className="border rounded-3">
                        <RemoveRedEyeOutlinedIcon sx={{color:"#000000",fontSize:"18px"}}  />
                       </IconButton>
                       <IconButton onClick={()=> handleDeleteRoleShow(role?.role?.id)} disableRipple size='small' className="border rounded-3">
                        <DeleteOutlineOutlinedIcon sx={{fontSize:"18px"}}  fontSize='small' color='error'/>
                       </IconButton>
                     </div>
                </div>
</>
                  )
                
                })}
            
               </div>

             </div>
              : 
               value == 2?
             <>
             <div className="border rounded-3 min-vh-100">
                <div className="d-flex justify-content-between align-items-center px-4 py-3">
                  <h5 className="m-0 fw-semibold">Expenses</h5>
             <div className=''>  
                <div onClick={(e) => setAnchorEl(e.currentTarget)} className="btn btn-light">
                  <Tune
                  style={{ cursor: "pointer" }}
                  
                />
                </div>
                
                <Menu
                className='my-1'
                  anchorEl={anchorEl}
                  open={open}
                  onClose={() => 
                  setAnchorEl(null)
                  
                  }
                  PaperProps={{
                    sx: {
                      p: 1,      
                      minWidth: 150,
                      backgroundColor:"#F9F9F9" ,
                      borderRadius:"10px"
                      
                    }
                  }}
                >
                  {expensesStatuses.map((item) => (
                   <div className="">
                     <MenuItem
                      key={item.value}
                      onClick={() => {
                        setSubmitChangeStatus(item.value);
                      }}
                     
                      
                    >
                      <div className="p-2 d-flex gap-3 align-items-center">
                        <img src={item.icon} alt="" />
                        <div className="label-size m-0">{item.key}</div>
                      </div>
                    </MenuItem>
                   </div>
                  ))}
                </Menu>
                
                
                          
                          </div>
                    

                </div>
                <div className="row g-4 mx-2 my-1"> 
                  {statisticsExpenses.map((item)=>
                    <div className="col-md-3 col-12 ">
                      <div style={{backgroundColor:`${item.border_color}`, border:`1px solid ${item.background_color}`}}  className="w-100 rounded-2  p-3">
                        <div className="d-flex gap-2 align-items-center mx-1">
                          <img style={{width:"25px"}} src={`${item.icon}`} alt="" />
                          <h6  className="Expenses-status-color fw-semibold m-0">{item.key}</h6>
                        </div>
                        <div className="my-3">
                          <h5 className="fw-bold">{`${Number(item?.amount)?.toLocaleString("en-US")} EGP`}</h5>
                        </div>
                      </div>
                  </div>
                  )}
         
                </div>
                  {/* table data */}
                        <div className="my-4 mx-3">
                           {staffExpenses.length > 0 ?    <div className="data-grid-small">
                          
                           
                            <Paper sx={{ height: "auto", width: "100%" }}>
                              <DataGrid
                                rows={filteredExpenses}
                                columns={columns}
                                initialState={{ pagination: { paginationModel } }}
                                pageSizeOptions={[5, 10, 20, 50]}
                                checkboxSelection
                                sx={{  overflow: "hidden" }}
                                slotProps={{
                                  pagination: {
                                    sx: {
                                      justifyContent: "center",
                                      display: "flex",
                                      alignItems: "center",
                                    },
                                  },
                                }}
                              />
                            </Paper>
                
                          </div> :      <div className="flex flex-column text-center border rounded-3 p-2">

            <img src={noData} alt="no-data" />
            <p style={{ color: "#535353" }} className=''>No available Expenses for this Staff</p>
          </div>}
                         
                   
                
                
                
                        </div>
             </div>
             </> : value == 3 ?  <>
              <div className="border rounded-3 min-vh-100">
                <div className="mx-4 px-2 py-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className='m-0'>Notes</h5>
                    <button onClick={handleNoteModalShow} className='btn btn-light'><Add sx={{marginInline:"3px"}}/>Add Note</button>
                  </div>
                   <div className="my-4">
                          {staffNotes.length > 0 ?
                           <div className="data-grid-small">
                         
                            <Paper sx={{ height: "auto", width: "100%" }}>
                              <DataGrid
                                rows={staffNotes}
                                columns={NotesColumns}
                                initialState={{ pagination: { paginationModel } }}
                                pageSizeOptions={[5, 10, 20, 50]}
                                checkboxSelection
                                sx={{  overflow: "hidden" }}
                                slotProps={{
                                  pagination: {
                                    sx: {
                                      justifyContent: "center",
                                      display: "flex",
                                      alignItems: "center",
                                    },
                                  },
                                }}
                              />
                            </Paper>
                
                          </div> 
                          : <div className="flex flex-column text-center">
                
                            <img src={noData} alt="no-data" />
                            <p style={{ color: "#535353" }} className=''>No staff notes yet. All the notes will appear here once you get started.</p>
                          </div>}
                
                
                
                        </div>
                </div>
             </div>
             </>
             : value == 4 ? 
              <>
               <div className="border rounded-3 min-vh-100">
                <div className="mx-4 px-2 py-3">
                                <div className="my-2 ">
                  <h5 className="m-0 fw-semibold">Client Reviews</h5>
                </div>
                   <div className="row g-4  my-1"> 
                  {clientsReviewsCard.map((item)=>
                    <div className="col-md-3 col-12 ">
                      <div style={{backgroundColor:`${item.backgroundColor}`, border:`1px solid ${item.borderColor}`}}  className="w-100 rounded-2  p-3">
                        <div className="d-flex gap-2 align-items-center mx-1">
                          <img style={{width:"25px"}} src={`${item.image}`} alt="" />
                          <h6  className="Expenses-status-color fw-semibold m-0">{item.title}</h6>
                        </div>
                        <div className="my-3">
                          <h5 className="fw-bold">{item.value}</h5>
                        </div>
                      </div>
                  </div>
                  )}

                </div>
                   <div className="my-4">
                      <div className="">
                          <h6 className="fw-semibold">
                            Client Comments
                          </h6>
                        </div>
                        <div className="d-flex align-items-center" style={{ width: "70%" }}>
                          <div className="w-50">
                            <FormControl fullWidth variant="outlined" size="small">
                
                              <OutlinedInput
                                id="search-orders"
                                placeholder='Search by name or order ID'
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton>
                                      <Search />
                                    </IconButton>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                          </div>
                          <div className="w-25 mb-2 mx-2 position-relative">
                            <input
                              type="date"
                              className="date-input form-control"
                              value={filterDate}
                              onChange={(e) => {
                                setFilterDate(e.target.value);
                                // setPage(0);
                              }}
                            />
                
                            {filterDate && (
                              <button
                                type="button"
                                className="btn btn-sm btn-light position-absolute"
                                style={{
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  padding: "2px 6px",
                                  fontSize: "12px",
                                }}
                                onClick={() => {
                                  setFilterDate("");
                                  // setPage(0);
                                }}
                              >
                                ✕
                              </button>
                            )}
                          </div>
                
                
                        </div>
                   </div>
                 <div className="my-4 border-bottom pb-3">
                    <div className=" d-flex justify-content-between align-items-center">
                      <div className="d-flex gap-2 align-items-center">
                        <div style={{width:"60px",height:"60px", borderRadius:"50%", backgroundColor:'#1834C9',color:"white"}} className="fs-3 d-flex justify-content-center align-items-center">Z</div>
                        <div className="">
                          <h6 className="">Zeyad Mohamed</h6>
                          <p className='main-text-color label-size m-0'>Order ID: #1205</p>
                        </div>
                      </div>
                      <div className="">
                            <Stack sx={{marginBottom:"10px"}} spacing={1}>
          <Rating name="half-rating-read" defaultValue={5} precision={0.5} readOnly />
                                  </Stack>
    <p className='main-text-color label-size text-end m-0 me-1'>3 days ago</p>
    
                      </div>
                    
                   </div>
                     <div style={{direction:"rtl"}} className="my-4">
                        <p className="">الخدمة كانت ممتازة جدًا من البداية للنهاية. الفنيين جم في الوقت المحدد، واهتموا بكل التفاصيل الصغيرة اللي أنا محتاجها. كل الأدوات والمعدات كانت جاهزة، والعملية تمت بسرعة وبدون أي مشاكل. حسيت بالراحة لأن كل شيء كان منظم بشكل محترف والنتيجة كانت ممتازة جدًا.</p>
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-12">
                          <img className='rounded-3 w-100' src={carImg} alt="" />
                        </div>
                            <div className="col-md-6 col-12">
                          <img className='rounded-3 w-100' src={carImg} alt="" />
                        </div>
                      </div>
                 </div>
                </div>
             </div>
             </>
             :
             value == 5 ?
      <>
               <div className="border rounded-3 min-vh-100">
                <div className="mx-4 px-2 py-3">
                                      <div className="my-2 ">
                  <h5 className="m-0 fw-semibold">ESTBN Reviews</h5>
                </div>
                   <div className="row g-4  my-1"> 
                  {clientsReviewsCard.map((item)=>
                    <div className="col-md-3 col-12 ">
                      <div style={{backgroundColor:`${item.backgroundColor}`, border:`1px solid ${item.borderColor}`}}  className="w-100 rounded-2  p-3">
                        <div className="d-flex gap-2 align-items-center mx-1">
                          <img style={{width:"25px"}} src={`${item.image}`} alt="" />
                          <h6  className="Expenses-status-color fw-semibold m-0">{item.title}</h6>
                        </div>
                        <div className="my-3">
                          <h5 className="fw-bold">{item.value}</h5>
                        </div>
                      </div>
                  </div>
                  )}

                </div>
                   <div className="my-4">
                     
                        <div className="d-flex align-items-center" style={{ width: "70%" }}>
                          <div className="w-50">
                            <FormControl fullWidth variant="outlined" size="small">
                
                              <OutlinedInput
                                id="search-orders"
                                placeholder='Search by name or order ID'
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton disableRipple >
                                      <Search />
                                    </IconButton>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                          </div>
                          <div className="w-25 mb-2 mx-2 position-relative">
                            <input
                              type="date"
                              className="date-input form-control"
                              value={filterDate}
                              onChange={(e) => {
                                setFilterDate(e.target.value);
                                // setPage(0);
                              }}
                            />
                
                            {filterDate && (
                              <button
                                type="button"
                                className="btn btn-sm btn-light position-absolute"
                                style={{
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  padding: "2px 6px",
                                  fontSize: "12px",
                                }}
                                onClick={() => {
                                  setFilterDate("");
                                  // setPage(0);
                                }}
                              >
                                ✕
                              </button>
                            )}
                          </div>
                
                
                        </div>
                   </div>
                   <div className="my-4 border-bottom">
                        <div className=" d-flex justify-content-between align-items-center">
                      <div className="d-flex gap-2 align-items-stretch">
                        <div style={{width:"60px",height:"60px", borderRadius:"50%", backgroundColor:'#1834C9',color:"white"}} className="fs-3 d-flex justify-content-center align-items-center">Z</div>
                        <div className=" my-uto">
                          <h6 className="">Zeyad Mohamed</h6>
                          <p className='main-text-color label-size m-0'>Order ID: #1205</p>
                        </div>
                        <div style={{fontSize:"12px"}}  className="">
                          <span  className="bg-dark text-white px-2 rounded-4">Engineer</span>
                        </div>
                      </div>
                      <div className="">
                            <Stack sx={{marginBottom:"10px"}} spacing={1}>
      <Rating name="half-rating-read" defaultValue={5} precision={0.5} readOnly />
                                  </Stack>
    <p className='main-text-color label-size text-end m-0 me-1'>3 days ago</p>
    
                      </div>
                    
                   </div>
                     <div style={{direction:"rtl",}} className="my-4">
                        <p className="">الخدمة كانت ممتازة جدًا من البداية للنهاية. الفنيين جم في الوقت المحدد، واهتموا بكل التفاصيل الصغيرة اللي أنا محتاجها. كل الأدوات والمعدات كانت جاهزة، والعملية تمت بسرعة وبدون أي مشاكل. حسيت بالراحة لأن كل شيء كان منظم بشكل محترف والنتيجة كانت ممتازة جدًا.</p>
                      </div>
                   </div>
                   <div className="my-4 border-bottom">
                        <div className=" d-flex justify-content-between align-items-center">
                      <div className="d-flex gap-2 align-items-stretch">
                        <div style={{width:"60px",height:"60px", borderRadius:"50%", backgroundColor:'#1834C9',color:"white"}} className="fs-3 d-flex justify-content-center align-items-center">Z</div>
                        <div className=" my-uto">
                          <h6 className="">Zeyad Mohamed</h6>
                          <p className='main-text-color label-size m-0'>Order ID: #1205</p>
                        </div>
                        <div style={{fontSize:"12px"}}  className="">
                          <span  className="bg-dark text-white px-2 rounded-4">Engineer</span>
                        </div>
                      </div>
                      <div className="">
                            <Stack sx={{marginBottom:"10px"}} spacing={1}>
      <Rating name="half-rating-read" defaultValue={5} precision={0.5} readOnly />
                                  </Stack>
    <p className='main-text-color label-size text-end m-0 me-1'>3 days ago</p>
    
                      </div>
                    
                   </div>
                     <div style={{direction:"rtl",}} className="my-4">
                        <p className="">الخدمة كانت ممتازة جدًا من البداية للنهاية. الفنيين جم في الوقت المحدد، واهتموا بكل التفاصيل الصغيرة اللي أنا محتاجها. كل الأدوات والمعدات كانت جاهزة، والعملية تمت بسرعة وبدون أي مشاكل. حسيت بالراحة لأن كل شيء كان منظم بشكل محترف والنتيجة كانت ممتازة جدًا.</p>
                      </div>
                   </div>
                </div>
             </div>
             </> :
              <>
             <div className="border rounded-3 min-vh-100">      
              <div className="mx-3 px-2 py-3">
                <h5 className="fw-semibold">Shifts</h5>
                   <div className="my-4">
                <div className="data-grid-small">
                         
                            <Paper sx={{ height: "auto", width: "100%" }}>
                              <DataGrid 
                                rows={staffShifts}
                                columns={ShiftsColumns}
                                initialState={{ pagination: { paginationModel } }}
                                pageSizeOptions={[5, 10, 20, 50]}
                                checkboxSelection
                                sx={{  overflow: "hidden" }}
                                slotProps={{
                                  pagination: {
                                    sx: {
                                      justifyContent: "center",
                                      display: "flex",
                                      alignItems: "center",
                                    },
                                  },
                                }}
                              />
                            </Paper>
                
                          </div> 
              </div>
              </div>
           
                    
             </div>
             </>
             }
        </div>
    </div>
</div>
</>


)
}

export default StaffProfile